<style lang="scss" scope>
.toolbar {
  @include border-bottom();
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>
<template>
    <el-card shadow="never" class="l-main-card">
        <div class="l-container-sider">
            <l-applet-org-list @on-before-check="loading = true" @on-after-check="aftercheckOrg"></l-applet-org-list>
        </div>
        
        <!--右边菜单列表-->
        <div class="l-container-content" v-loading="loading">
            <div class="l-menu-box">
                <!-- <div class="l-container-title"><i class="el-icon-user-solid" /><b>器材缺项查询</b></div> -->
                
                <div class="l-table-place">
                    <div class="flex flex-warp">
                      
                      <div class="flexs items-center ivu-mt ivu-mr">
                        <p class="mr1">消防柜</p>
                        <el-select v-model="search_data.cabinet_id" placeholder="请选择消防柜">
                          <el-option v-for="item in cabinet_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                      </div>
                      
                      <div class="flexs items-center ivu-mt ivu-mr">
                        <p class="mr1">名称</p>
                        <el-input
                          placeholder="请输入名称"
                          v-model="search_data.name"
                          class="input-with-select"
                          style="width: 80%;"
                        >
                          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                        </el-input>
                      </div>
                      <div class="flexs items-center ivu-mt ivu-mr">
                        <p class="mr1">分类</p>
                        <el-cascader v-model="search_data.type_id" :options="tree_node" :props="{ checkStrictly: true }" clearable style="width:500px;"/>
                        </el-cascader>
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                      </div>
                
                    </div>    
                      
                </div>
                
                
                <div class="l-menu-list-main" style="bottom: 0; top: 150px">
                    <!--分页-->
                    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
                    
                    <l-table :data="data" v-loading="loading" row-key="index">
                        <el-table-column v-for="(item,index) in columns" :key="index" v-bind="{...item}" :label="item.label" show-overflow-tooltip>
                          
                        </el-table-column>
                    </l-table>
  
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import UserChangePwd from "@/views/user/ChangePwd";
import { emailFormat, phoneFormat } from "@/utils/Fuc";
import { STATES, STATE_NAMES } from "@/common/constants/resources";
import OrgList from "../public/OrgList.vue";
let columns = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "60"
  },
  {
    prop: "org_name",
    label: "所属上级",
    fixed: true,
    width: "100"
  },
  // {
  //   prop: "template_name",
  //   label: "模板柜",
  //   fixed: true,
  //   Width: "100"
  // },
  {
    prop: "site_name",
    label: "消防柜",
    fixed: true,
    Width: "100"
  },
  {
    prop: "material_name",
    label: "器材名称",
    fixed: true,
    width: "150"
  },
  {
    prop: "specification_name",
    label: "型号规格",
    fixed: true,
    width: "100"
  },
  {
    prop: "tm_material_quantity",
    label: "满装数量",
    fixed: true,
    width: "100"
  },
  {
    prop: "stock_material_quantity",
    label: "现有数量",
    fixed: true,
    width: "100"
  },
  {
    prop: "defect_material_quantity",
    label: "缺损数量",
    fixed: true,
    width: "100"
  },
  {
    prop: "fix_material_quantity",
    label: "送修数量",
    fixed: true,
    width: "100"
  },
];

export default {
  name: "cabinet-index",
  components: {
    [Edit.name]: Edit,
    [UserChangePwd.name]: UserChangePwd,
    [OrgList.name]: OrgList
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      info_visible: false, //是否显示编辑
      info_id: 0,
      org_id:0,
      change_pwd_visible: false, //是否显示修改密码
      change_pwd_id: 0,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
      //搜索
      search_visible: false,
      search_loading: true,
      site_tree: [],
      role_list: [],
      tree_node: [],
      cabinet_list: [],
      search_data: {
        keywords: "",
        name: "",
        mobile: "",
        email: "",
        site_id: undefined,
        role_id: "",
        org_id: "",
      },

      rel_search_data: {},
      show_more_search: false,
     
      re_fixed_list: ["index", "state"],
      fixed_list: ["index", "state"],
    };
  },

  computed: {
    columns() {
      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {
    fixed_list(val) {
      if (val.length > 3) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    emailFormat(num) {
      return emailFormat(num);
    },
    phoneFormat(num) {
      return phoneFormat(num);
    },

    //加载列表方法
    aftercheckOrg(org_id) {
        // let org_id = org_id;
        
        this.loading = true;
        this.$_invoke(`materialEnquiry_getCabinetListByOrgId`, {org_id }).then((ret) => {
            this.cabinet_list = ret.cabinet_list;
        }).finally(() => {
          this.loading = false;
        });

      this.getList(org_id);
    },
    
    //获取数据
    getList(org_id) {
      this.org_id = org_id;
      this.loading = true;
      
      if (this.rel_search_data.type_id != undefined && typeof this.rel_search_data.type_id != "number") {
        const type_id_len = this.rel_search_data.type_id.length;
        this.rel_search_data.type_id = this.rel_search_data.type_id[type_id_len - 1];
      }
      
      this.$_invoke("materialEnquiry_getMaterialDefectList", {
        page: this.page,
        page_size: this.page_size,
        org_id: org_id,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
          this.tree_node = ret.type_node;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索数据
    getSearchData() {
      this.search_loading = true;
      this.$_invoke("adminUser_getSearchData")
        .then((ret) => {
          this.site_tree = ret.site_tree;
          this.role_list = ret.role_list;
        })
        .finally(() => {
          this.search_loading = false;
        });
    },

    //显示搜索
    showSearch() {
      this.search_visible = true;
      this.getSearchData();
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.search_data.org_id = this.org_id;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //显示详情
    showInfo(id) {
        // console.log(id);
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //修改状态
    changeState(row) {
      // console.log(row.id);
      this.change_state_loading.push(row.id);

      this.$_invoke(`adminUser_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
           console.log(e);
        })
        .finally(() => { });
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.change_pwd_visible = true;
      });
    },

    //修改密码成功回掉
    onChangePwdSuccess() {
      this.change_pwd_visible = false;
    },

    //删除
    del(id) {
      this.$confirm(
        "确定删除该条记录吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$_invoke(`trainManage_delete`, { id: id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },

    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
  },
};
  </script>